<script setup lang="ts">
const props = defineProps<{
    vatOption: string
}>()
</script>

<template>
    <span
        class="inline-block uppercase cursor-pointer rounded bg-primary mr-1 !text-[9px] !text-white !p-[5px] !font-bold !leading-[10px]"
    >
        {{ $t('general.' + vatOption) }}
    </span>
</template>

<style scoped lang="scss"></style>
